// @flow
import ReactDOM from 'react-dom'
import { customAlphabet } from 'nanoid'
import type { BrowserHistory } from 'history'

import type { ExternalProps } from './types'
import { ExternalMenu } from './organisms/external-menu'
import './assets/menu.sass'

const customNanoid = customAlphabet('1234567890abcdef-', 22)
type Props = {|
  history: BrowserHistory,
  options: ExternalProps,
  afterRender?: () => void, // функция которая вызовется после рендера меню
  beforeRender?: () => void, // функция которая вызовется до рендера меню
  onUnmount?: () => void, // функция которая вызовется до рендера меню
|}

export class FoxfordMenu {
  _node: HTMLDivElement

  props: Props

  constructor({ history, options, afterRender, beforeRender, onUnmount }: Props) {
    if (!history) {
      throw new Error('History is not created')
    }

    if (options.header === true && !options.headerContainer) {
      throw new Error('In order to render header specify DOM container for it in "headerContainer" option.')
    }

    if (options.footer === true && !options.footerContainer) {
      throw new Error('In order to render footer specify DOM container for it in "footerContainer" option.')
    }

    if (options.header === true && !(options.headerContainer instanceof Element)) {
      throw new TypeError('headerContainer must be a DOM node.')
    }

    if (options.footer === true && !(options.footerContainer instanceof Element)) {
      throw new TypeError('footerContainer must be DOM node element.')
    }

    this.props = {
      options,
      history,
      afterRender,
      beforeRender,
      onUnmount,
    }

    const $root = document.createElement('div')

    $root.setAttribute('id', customNanoid())
    document.body && document.body.appendChild($root)

    this._node = $root

    if (options.rootColors === true) {
      // eslint-disable-next-line no-unused-expressions
      import(/* webpackMode: "eager" */ './assets/root.sass')
    }

    if (options.loadFonts === true) {
      // eslint-disable-next-line no-unused-expressions
      import(/* webpackMode: "eager" */ './assets/fonts.sass')
    }
  }

  getOptions = () => this.props.options

  setOptions = (options: ExternalProps) => {
    this.props.options = options
  }

  render() {
    ReactDOM.render(<ExternalMenu {...this.props} />, this._node)
  }
}
